import {ApiDeleteAdmin, ApiGetAdmin, ApiPatchAdmin, ApiPostAdmin} from "../../../shared/services/api-service";
import notificationsActionCreators
  from "../../../subscriber-app/store/notifications/action-creators";
import taskConfigCommitTypes from "./commitTypes";

const taskConfigActionCreators = {
  fetchConfigTaskGroups() {
    return (dispatch) =>
    {
      dispatch(this.setIsLoading('fetchConfigTaskGroups'));
      return ApiGetAdmin('/config-task-groups')
        .then(res => {
          dispatch({
            type: taskConfigCommitTypes.SET_TASK_GROUPS_CONFIG,
            taskGroups: res
          });
          dispatch(this.setIsLoading('fetchConfigTaskGroups'));
        })
        .catch(err => dispatch(notificationsActionCreators.addError(err.message)))
    }
  },

  attachTasks(config_task_groups) {
    return (dispatch, getState) => {

      dispatch(this.setIsLoading('attachTasks'));
      return ApiPostAdmin(`/departments/${getState().common.userContext.departmentGuid}/assign-config-task-groups`, {
        config_task_groups
      })
        .then(res => {
          dispatch(this.setIsLoading('attachTasks'));
        })
        .catch(err =>{
          dispatch(notificationsActionCreators.addError(err.message))
          return Promise.reject(err);
        })
    }

  },

  addTaskGroup(config_task_group) {
    return (dispatch) => {
      dispatch(this.setIsLoading('addTaskGroup'));
      return ApiPostAdmin('/config-task-groups', {
        config_task_group
      })
        .then(({guid}) => {
          dispatch(this.setIsLoading('addTaskGroup'));
          dispatch({
            type: taskConfigCommitTypes.PUSH_TASK_GROUP_CONFIG,
            taskGroup: {
              guid,
              ...config_task_group,
              tasks: []
            }
          })
        })
        .catch(err => dispatch(notificationsActionCreators.addError(err.message)))
    }
  },
  addTask(taskGroupGuid, config_task) {
    return (dispatch) => {
      dispatch(this.setIsLoading('addTask'));
      return ApiPostAdmin(`/config-task-groups/${taskGroupGuid}/config-task`, {
        config_task: {
          ...config_task
        }
      })
        .then(({guid}) => {
          dispatch(this.setIsLoading('addTask'));
          dispatch({
            type: taskConfigCommitTypes.PUSH_TASK_CONFIG,
            taskGroupGuid,
            task: {
              ...config_task,
              guid
            }
          })
        })
        .catch(err => dispatch(notificationsActionCreators.addError(err.message)))
    }
  },
  editTaskGroup(guid, config_task_group) {
    return (dispatch) => {
      dispatch(this.setIsLoading('editTaskGroup'));
      return ApiPatchAdmin('/config-task-groups', guid, {
        config_task_group
      })
        .then(res => {
          dispatch(this.setIsLoading('editTaskGroup'));
          dispatch({
            type: taskConfigCommitTypes.UPDATE_TASK_GROUP_CONFIG,
            taskGroup: config_task_group,
            guid
          })
        })
        .catch(err => dispatch(notificationsActionCreators.addError(err.message)))
    }
  },

  editTask(taskGroupGuid, guid, config_task) {
    return (dispatch) => {
      dispatch(this.setIsLoading('editTask'));
      return ApiPatchAdmin('/config-task', guid, {
        config_task
      })
        .then(res => {
          dispatch(this.setIsLoading('editTask'));
          dispatch({
            type: taskConfigCommitTypes.UPDATE_TASK_CONFIG,
            taskGroupGuid,
            task: config_task,
            guid
          })
        })
        .catch(err => dispatch(notificationsActionCreators.addError(err.message)))
    }
  },
  deleteTaskGroup(guid) {
    return (dispatch) => {
      dispatch(this.setIsLoading('deleteTaskGroup'));
      return ApiDeleteAdmin('/config-task-groups', guid)
        .then(res => {
          dispatch(this.setIsLoading('deleteTaskGroup'));
          dispatch({
            type: taskConfigCommitTypes.DELETE_TASK_GROUP_CONFIG,
            guid
          })
          dispatch(notificationsActionCreators.addSavedSuccessfully('Task group deleted'))
        })
        .catch(err => dispatch(notificationsActionCreators.addError(err.message)))
    }
  },
  deleteTask(taskGroupGuid, guid) {
    return (dispatch) => {
      dispatch(this.setIsLoading('deleteTask'));
      return ApiDeleteAdmin('/config-task', guid)
        .then(res => {
          dispatch(this.setIsLoading('deleteTask'));
          dispatch({
            type: taskConfigCommitTypes.DELETE_TASK_CONFIG,
            guid,
            taskGroupGuid
          })
          dispatch(notificationsActionCreators.addSavedSuccessfully('Task deleted'))
        })
        .catch(err => dispatch(notificationsActionCreators.addError(err.message)))
    }
  },
  setIsLoading(isLoading) {
    return {
      type: taskConfigCommitTypes.SET_TASK_CONFIG_IS_LOADING,
      isLoading
    }
  }
};

export default taskConfigActionCreators;